module.exports = __webpack_public_path__ + "img/charlie_icon.8f03fb2d.png";